export { equalizer };

function equalizer(auto) {
	let width = 1024;
	if (auto === "auto") {
		$("[data-equalizer-watch]").css("height", "auto");
	}
	$("[data-equalizer]").each(function () {
		var equalize = 'outerHeight';
		var type = 'height';
		var $children = $(this).find('[data-equalizer-watch]');
		var max = 0;
		$children.each(function () {
			var $element = $(this);
			var value;
			value = $element[equalize](); // call height(), outerHeight(), etc.
			if (value > max) {
				max = value;
			} // update max
		});
		if ($children.parent().hasClass("auction-card")) {
			width = 769;
		}
		if (window.innerWidth < width) {
			$children.css('height', 'auto'); // add CSS to children
		} else {
			$children.css(type, max + 'px'); // add CSS to children
		}
	});
}